<template>
    <v-alert border="bottom" colored-border icon="search" color="grey" outlined>
        <v-layout wrap>

            <v-flex xs12 v-if="!hideStore">
                <SelectStore @onChange="changeStore" />
            </v-flex>

            <v-flex xs12 v-if="hideDate == false && (disableDateWhenClient == false || selectedClient == null)">
                <DateInterval :label="$t('Data')" @onChange="changeDate" limit="93" />
            </v-flex>

            <v-flex xs12 v-if="!hideClient">
                <SelectClient @onChange="changeClient" :canDelete="canDeleteClient" />
            </v-flex>

            <v-flex xs12 v-if="!hideExam">
                <SelectExam @onChange="changeExam" :canDelete="canDeleteExam" />
            </v-flex>

        </v-layout>
    </v-alert>
</template>

<script>
import DateInterval from "@/components/core/DateInterval";
import SelectStore from "@/components/shared/SelectStore";
import SelectClient from "@/components/shared/SelectClient";
import SelectExam from "@/components/shared/SelectExam";

export default {

    components: { DateInterval, SelectStore, SelectClient, SelectExam },

    props: {
        hideClient: {
            type: Boolean,
            default: false,
        },
        hideStore: {
            type: Boolean,
            default: false,
        },
        hideExam: {
            type: Boolean,
            default: true,
        },
        hideDate: {
            type: Boolean,
            default: false,
        },
        disableDateWhenClient: {
            type: Boolean,
            default: false,
        },
        canDeleteClient: {
            type: Boolean,
            default: false,
        },
        canDeleteExam: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            dates: [],
            selectedStore: null,
            selectedClient: null,
        };
    },


    methods: {
        changeDate(event) {
            this.dates = event;
            this.$emit("changeDate", this.dates);
        },
        changeClient(item) {
            this.selectedClient = item;
            this.$emit("changeClient", this.selectedClient);
            if (this.disableDateWhenClient) {
                this.dates = [];
                this.$emit("changeDate", this.dates);
            }
        },
        changeExam(item) {
            this.$emit("changeExam", item);
        },
        changeStore(event) {
            this.selectedStore = event;
            this.$emit("changeStore", this.selectedStore);
        },
    }
};
</script>